import { render, staticRenderFns } from "./_tabAccounting.vue?vue&type=template&id=76a99e3c&scoped=true&"
import script from "./_tabAccounting.vue?vue&type=script&lang=js&"
export * from "./_tabAccounting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a99e3c",
  null
  
)

export default component.exports